import { useCallback, useEffect } from "react";
import { ConfigProvider, Spin } from "antd";
import { useParams } from "react-router-dom";
import enUS from "antd/locale/en_US";
import {
	getProductions2,
	removeProductions,
	saveProductions,
	getProductionDict,
} from "service/productionData";
import EditorTable from "../component/EditorTable";
import useLoading from "components/common/useLoading";
import { titleCase } from "utils/dataUtil";

const productionColumns = [
	{
		title: "Well Name",
		dataIndex: "well_name",
		key: "well_name",
	},
	{
		title: "Date",
		dataIndex: "prd_date",
		key: "prd_date",
		sorter: (aRec, bRec) => (aRec.prd_date > bRec.prd_date ? 1 : -1),
		width: 120,
	},
];

function ProductionEditor3(props) {
	const { uwi } = useParams();
	const [LoadingIcon, showLoadingIcon, hideLoadingIcon] = useLoading(
		<Spin size="large" />,
		50
	);

	const fetcher = useCallback((uwi, succeed, fail) => {
		getProductions2(
			{ uwis: uwi },
			(...values) => {
				succeed(...values);
			},
			(...values) => {
				fail(...values);
			}
		);
	}, []);

	const buildQuery = useCallback(() => {
		return uwi;
	}, [uwi]);

	useEffect(() => {
		getProductionDict(
			(res) => {
				let columnKeys = productionColumns.map((item) => item.key);
				let dictData = res.filter((item) => item.element !== 'uwi' && item.element !== 'well_name' && item.element !== 'prd_date' && !columnKeys.includes(item.element));
				const columns = dictData.map((item) => {
					let name = null;
					if (item.element_fullname) {
						name = item.element_fullname;
					} else {
						name = titleCase(item.element);
					}
					return {
						title: name,
						dataIndex: [item.element, "value"],
						key: item.element,
						width: 120,
					};
				});
				productionColumns.splice(2, 0, ...columns);
			},
			(error) => {
				console.error(error);
			}
		);
	}, []);

	return (
		<div style={{ height: "91vh", overflowY: "auto" }}>
			<LoadingIcon />
			<ConfigProvider
				locale={enUS}
				componentSize="middle"
				theme={{
					token: {},
					components: {},
				}}
			>
				<EditorTable
					columns={productionColumns || []}
					title="Well Production"
					// uwi={uwi}
					// allowNullUwi={false}
					showNewRow={() => false}
					dataFetcher={[
						buildQuery,
						fetcher,
						(data) => {
							let result = [];
							const { productions, wells } = data;
							if (productions == null || Object.keys(productions).length === 0) {
								return []
							}
							const recordsMap = new Map();
							const well_name = wells.find(
								(item) => item.uwi === uwi
							)?.well_name;
							const wellProductions = productions[uwi];
							for (let prd_index of Object.keys(
								wellProductions
							)) {
								const productions = wellProductions[prd_index];
								for (const dataItem of productions) {
									const [prd_date, record_id, prd_value] =
										dataItem;
									if (!recordsMap.has(prd_date)) {
										let record = {
											uwi: uwi,
											well_name: well_name,
											prd_date: prd_date,
										};
										recordsMap.set(prd_date, record);
									}
									let record = recordsMap.get(prd_date);
									record[prd_index] = {
										id: record_id,
										value: prd_value || 0,
									};
								}
							}
							result = Array.from(recordsMap.values());
							return result.map((item, index) => {
								return {
									...item,
									id: index,
								};
							});
						},
					]}
					dataSaver={[
						saveProductions,
						(rec, row) => {
							const record = { ...rec };
							const { prd_date } = record;
							delete record.uwi;
							delete record.prd_date;
							delete record.id;
							delete record.well_name;
							let result = {
								uwi,
								prd_date,
								data: {},
							};

							Object.keys(record)
								.filter((key) => key !== "index")
								.map((key) => {
									let dataObj = record[key];
									// console.log("dataObj", dataObj, dataObj.value, typeof dataObj);
									let dataValue = null;
									if (dataObj.value !== undefined) {
										dataValue = dataObj.value;
									} else {
										dataValue = parseInt(dataObj);
									}
									let keyValue = {
										value: dataValue,
									};
									row[key] &&
										(keyValue["id"] = row[key]["id"]);
									result.data[key] = keyValue;
									rec[key] = keyValue;
									return null;
								});
							return [result];
						},
					]}
					dataRemover={[
						removeProductions,
						(record, originData) => {
							const { uwi, prd_date } = record;
							let result = {
								data: [
									{
										uwi,
										date: prd_date,
										data: Object.keys(record).filter(
											(item) =>
												![
													"uwi",
													"prd_date",
													"id",
													"well_name",
												].includes(item)
										),
									},
								],
							};
							return result;
						},
					]}
					loadingIconActions={[showLoadingIcon, hideLoadingIcon]}
				/>
			</ConfigProvider>
		</div>
	);
}

export default ProductionEditor3;
